/**
 * #5068 — one door to both kits: a drawing's parts come from the 2D sketch kit or the 3D parts kit, and motion, labels
 * and the program API treat them alike through these.
 */
import type { DrawingPart } from './DrawingSchema';
import { isAbsolutePartsKit3d, isPartsKit3dName, placePart3d } from './partsKit3d';
import { isAbsoluteSketchKit, isSketchKitName, placeSketchPart, type Point } from './sketchKit';

export function isDrawingKitName(name: string, view: '2d' | '3d'): boolean { return view === '3d' ? isPartsKit3dName(name) : isSketchKitName(name); }
/** Drawn from sheet points (arrows, springs, rods, pipes): such a part moves, but does not turn. */
export function isAbsoluteDrawingKit(name: string): boolean { return isAbsoluteSketchKit(name) || isAbsolutePartsKit3d(name); }
/** A part's anchors and footprint on the sheet, whichever kit it comes from. */
export function placeDrawingPart(part: DrawingPart, motion: { offset?: Point; turn?: number; ends?: { from?: Point; to?: Point } } = {}):
  { anchors: Record<string, Point>; box: { x: number; y: number; width: number; height: number } } | null {
  return isPartsKit3dName(part.kit) ? placePart3d(part, motion) : placeSketchPart(part, motion);
}
